module.exports = __webpack_public_path__ + "static/media/sweet_view_3.1a5288c3.jpg";